var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"image-container"},[(_vm.retinaSrc)?_c('source',{ref:"retinaSource",attrs:{"srcset":_vm.retinaSrcDPI,"media":"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)"}}):_vm._e(),_vm._v(" "),(_vm.webpSrc)?_c('source',{ref:"webpSource",attrs:{"srcset":_vm.webpSrc,"type":"image/webp"}}):_vm._e(),_vm._v(" "),_c('img',{ref:"img",staticClass:"image-container__image img-fluid",class:[
            { 'image-container__image--waiting': _vm.shouldAnimate },
            { 'image-container__image--contain': _vm.contain },
            _vm.staticClass,
            _vm.imgClass
        ],attrs:{"src":_vm.src,"alt":_vm.alt,"height":_vm.height,"width":_vm.width,"loading":_vm.loadingMode},on:{"error":_vm.trySubstitute}})])
}
var staticRenderFns = []

export { render, staticRenderFns }